import { FC, ReactElement } from 'react';
import { StyledContainer, TitleStyled, ValueStyled } from './ChartTooltipContent.styles';
import { ChartTooltipContentProps } from './ChartTooltipContent.type';
import { TooltipVariants } from '../constants';

const ChartTooltipContent: FC<ChartTooltipContentProps> = ({ chartName, payload, title, tooltipVariant }): ReactElement => {
  return (
    <StyledContainer data-testid={`${chartName}-tooltip`}>
      <TitleStyled data-testid={`${chartName}-tooltip-title`}>{`${title}: `}</TitleStyled>
      {payload?.reverse()?.map(({ value, payload }, index: number) => {
        return (
          <ValueStyled data-testid={`${chartName}-tooltip-value`} key={index}>
            { tooltipVariant === TooltipVariants.CONVERSION &&
              `${payload.converted as string}, ${Number(value).toLocaleString()}%`
            }
            {!tooltipVariant && Number(value).toLocaleString()}
          </ValueStyled>
        );
      })}
    </StyledContainer>
  );
};

export default ChartTooltipContent;
